import React from 'react';
import { BoxIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
interface ServiceCardProps {
  icon: BoxIcon;
  title: string;
  description: string;
  delay?: number;
  href?: string;
}
export function ServiceCard({
  icon: Icon,
  title,
  description,
  delay = 0,
  href
}: ServiceCardProps) {
  // Map delay to stagger class (delay is typically 0, 0.1, 0.2, etc.)
  const staggerIndex = Math.round(delay * 10);
  const staggerClass = staggerIndex > 0 ? `stagger-${Math.min(staggerIndex, 8)}` : '';
  const CardContent = <div className={`scroll-fade-in-up ${staggerClass} card-premium p-6 rounded-xl border border-border transition-all duration-300 cursor-pointer h-full hover:-translate-y-1.5`} data-id="element-140">
      <div className="w-12 h-12 rounded-lg flex items-center justify-center mb-4 border border-border bg-gradient-to-br from-background to-blue-50/50" data-id="element-141">
        <Icon className="w-6 h-6 text-accent" data-id="element-142" />
      </div>
      <h3 className="text-xl font-bold text-ink mb-2" data-id="element-143">{title}</h3>
      <p className="text-muted leading-relaxed" data-id="element-144">{description}</p>
    </div>;
  if (href) {
    return <Link to={href} className="block h-full" data-id="element-145">
        {CardContent}
      </Link>;
  }
  return CardContent;
}